// Restricted accounts that should only ever see the "All Batches" module
// (and, within it, none of the superAdmin-only Journey Dashboard / Recent
// Changes shortcuts). Configured via REACT_APP_BATCH_ONLY_EMAILS, same
// pattern as REACT_APP_SUPER_ADMIN_EMAILS in Attendance.tsx.
const BATCH_ONLY_EMAILS = (process.env.REACT_APP_BATCH_ONLY_EMAILS || "")
  .split(",")
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

export function isBatchOnlyEmail(email?: string | null): boolean {
  if (!email) return false;
  return BATCH_ONLY_EMAILS.includes(email.trim().toLowerCase());
}

export function getStoredUserEmail(): string | null {
  try {
    const userData = localStorage.getItem("user");
    if (!userData) return null;
    return JSON.parse(userData)?.email || null;
  } catch {
    return null;
  }
}

export function isCurrentUserBatchOnly(): boolean {
  return isBatchOnlyEmail(getStoredUserEmail());
}
